<template>
  <div class="flex flex_gap_5">
    <v-popover
      :auto-hide="true"
    >
      <button type="button" class="btn btn-xs btn-outline-success">
        <i class="icon-fa icon-fa-phone-square"/> Быстрый контакт
      </button>
      <template slot="popover">
        <div>
          <p>Менеджер свяжется с клиентом для решения вопроса</p>
          <div>
            <LoadingButton
              title="Вопрос по товару"
              className="btn btn-outline-info mb-1"
              :loading="actionBtnLoading"
              :color="$constants.LOADING_COLOR"
              :onClick="() => sendManagerRequest('drug')"
            />
            <LoadingButton
              title="Вопрос по цене"
              className="btn btn-outline-info mb-1"
              :loading="actionBtnLoading"
              :color="$constants.LOADING_COLOR"
              :onClick="() => sendManagerRequest('price')"
            />
            <LoadingButton
              title="Вопрос по адресу"
              className="btn btn-outline-info mb-1"
              :loading="actionBtnLoading"
              :color="$constants.LOADING_COLOR"
              :onClick="() => sendManagerRequest('address')"
            />
            <LoadingButton
              title="Вопрос по оплате"
              className="btn btn-outline-info mb-1"
              :loading="actionBtnLoading"
              :color="$constants.LOADING_COLOR"
              :onClick="() => sendManagerRequest('payment')"
            />
          </div>
        </div>
      </template>
    </v-popover>
    <v-popover
      :auto-hide="true"
    >
      <button type="button" class="btn btn-xs btn-outline-info">
        <i class="icon-fa icon-fa-info info_fa"/>
      </button>
      <template slot="popover">
        <div>
          <p class="mb-2">Цель запроса звонка оператора
            - быстрый ответ на вопросы клиента
            - "спасти" заказ во время доставки, или лучше до приезда к клиенту.</p>
          <p>О результатах диалога, оператор пишет сообщение по факту совершенного звонка.</p>
        </div>
      </template>
    </v-popover>
  </div>
</template>

<script>

import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";

export default {
  components: {LoadingButton},
  props: ['order'],
  data() {
    return {
      actionBtnLoading: false,
    }
  },
  methods: {
    async sendManagerRequest(alias) {
      this.actionBtnLoading = true;
      const {data} = await api.post('/new/client/order/request', {
        action: 'phoneCallRequest',
        type: alias,
        order_id: this.order.id
      })
      if (data.success) {
        toastr['success']('Запрос отправлен')
      } else {
        toastr['warning'](data.message ?? 'Ошибка!')
      }
      this.actionBtnLoading = false;
    },
  }
}

</script>
